import {
  VersioningStatusEnum,
  VersioningStatusUIEnum,
} from '@/enums/VersioningStatus';

export const convertVersioningStatusToUIEnum = (
  status: VersioningStatusEnum,
  version: number,
): VersioningStatusUIEnum => {
  if (status === VersioningStatusEnum.VERSIONING) {
    return version === 1.0
      ? VersioningStatusUIEnum.DRAFT
      : VersioningStatusUIEnum.VERSIONING;
  }
  return VersioningStatusUIEnum[status];
};
